export default "__VITE_ASSET__B4fjt1Ej__"